import { useDrag, useDrop } from 'react-dnd';

const DND_TYPES = {
  MEDIA: 'MEDIA',
};

const DraggableMediaItem = ({ index, moveItem, children, onDragging, disableDragAndDrop }) => {
  const [, ref] = useDrag({
    type: DND_TYPES.MEDIA,
    item: { index },
  });

  const [{ isDragging }, drop] = useDrop({
    accept: DND_TYPES.MEDIA,
    drop: draggedItem => {
      moveItem(draggedItem.index, index);
      draggedItem.index = index;
    },
    hover: draggedItem => {
      if (draggedItem.index !== index) {
        onDragging(draggedItem.index, index);
        draggedItem.index = index;
      }
    },
  });

  return (
    <div
      ref={node => {
        if (!disableDragAndDrop) {
          ref(drop(node));
        }
      }}
      style={{
        opacity: isDragging ? 0.4 : 1,
        cursor: 'grab',
        borderRadius: '8px',
        overflow: 'hidden',
        height: '24rem',
      }}>
      {children}
    </div>
  );
};

export default DraggableMediaItem;
